<template>
  <v-layout column wrap ma-2>
    <v-layout column wrap>
      <v-layout row wrap>
        <v-flex xs12 md9 align-self-center>
          <v-layout column wrap>
            <v-layout row wrap>
              <v-flex xs12 class="subheading">
                <skeleton duration=".6" theme="flex-outer" style="width: 200px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                  <tb-skeleton :aspect-ratio="0.1"></tb-skeleton>
                </skeleton>
                <span class="title font-weight-black primary--text" v-if="called.id">
                  #{{ called.id }}
                </span>
                <span class="title font-weight-regular primary--text" v-if="called.id"> - {{ called.title }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 class="subheading black--text">
                <skeleton duration=".6" theme="flex-outer" style="width: 150px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                  <tb-skeleton :aspect-ratio="0.1"></tb-skeleton>
                </skeleton>
                <span v-if="called.id">Projeto</span>
                <span class="font-weight-regular primary--text" v-if="called.id">{{ called.project ? called.project.name : '' }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <skeleton duration=".6" theme="flex-outer" style="width: 300px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                  <tb-skeleton :aspect-ratio="0.05"></tb-skeleton>
                </skeleton>
                <span class="subheading grey--text" v-if="called.id">
                  Criado por <strong>{{ called.called_users[0].user.name }}</strong> em {{ called.created_at | prDateTime }} - Atualizado em {{ called.updated_at | prDateTime }}
                </span>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
        <v-flex xs12 md3 pt-0 class="mt-0" text-md-right align-self-start>
          <v-btn small flat class="primary--text ma-0" @click="editCalled()" :disabled="!called.id">
            <v-icon small>edit</v-icon>
            Editar
          </v-btn>
          <v-btn small flat class="primary--text ma-0" @click="updateCalledData()">
            <v-icon small>autorenew</v-icon>
            Atualizar
          </v-btn>
          <v-btn small flat class="primary--text ma-0" @click="goToBack()">
            <v-icon>keyboard_arrow_left</v-icon>
            Voltar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout column wrap mt-3>
      <v-layout row wrap>
        <v-flex xs12 pa-0>
          <v-tabs
            v-model="tabActive"
            color="primary"
            slider-color="white">
            <v-tab class="white--text" ripple href="#tab-dados">
              Dados
            </v-tab>
            <v-tab class="white--text" :disabled="!called.call_histories_count" ripple href="#tab-historico" >
              <v-badge color="success">
                <span slot="badge" v-if="called.call_histories_count">
                  {{ called.call_histories_count }}
                </span>
                Histórico
              </v-badge>
            </v-tab>
            <v-tab-item value="tab-dados">
              <v-layout column wrap ml-0 mr-0 mt-3>
                <v-layout row wrap mb-3 v-if="called.called_status">
                  <v-flex xs2 class="alert-status-height">
                    <v-alert
                      :value="true"
                      :color="verifyColorCalledStatus(called.called_status)"
                      outline
                      :icon="verifyIconCalledStatus(called.called_status)">
                      Status do Chamado: <br>
                      <skeleton duration=".6" theme="flex-outer" style="width: 100px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                        <tb-skeleton :aspect-ratio="0.2"></tb-skeleton>
                      </skeleton>
                      <span class="font-weight-bold" v-if="called.id">{{ called.called_status.description }}</span>
                    </v-alert>
                  </v-flex>
                  <v-flex xs2 class="alert-status-height">
                    <v-alert
                      :value="true"
                      :color="verifyColorCycleStatus(called.cycle.active)"
                      outline
                      :icon="verifyIconCycleStatus(called.cycle.active)">
                      Status do Ciclo: <br>
                      <skeleton duration=".6" theme="flex-outer" style="width: 100px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                        <tb-skeleton :aspect-ratio="0.2"></tb-skeleton>
                      </skeleton>
                      <span class="font-weight-bold" v-if="called.id">{{ cycleStatus[called.cycle.active] }}</span>
                    </v-alert>
                  </v-flex>
                </v-layout>
                <v-layout row wrap mt-2>
                  <!-- Sessão Dados do chamado" -->
                  <v-flex xs12 md8>
                    <v-card flat>
                      <v-system-bar status color="grey lighten-2" class="pa-3">
                        <span class="primary--text">Dados do Chamado</span>
                      </v-system-bar>
                      <v-card-text class="cart-text-border">
                        <v-layout column wrap>
                          <v-layout row wrap>
                            <v-flex xs12 md3>
                              <span class="grey--text">Projeto:</span>
                              <br>
                              <skeleton duration=".6" theme="flex-outer" style="width: 100px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                                <tb-skeleton :aspect-ratio="0.2"></tb-skeleton>
                              </skeleton>
                              <span v-if="called.id">{{ called.project ? called.project.name : '' }}</span>
                            </v-flex>
                            <v-flex xs12 md3 v-if="called.cycle">
                              <span class="grey--text">Ciclo:</span>
                              <br>
                              <skeleton duration=".6" theme="flex-outer" style="width: 100px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                                <tb-skeleton :aspect-ratio="0.2"></tb-skeleton>
                              </skeleton>
                              <span v-if="called.id">{{ called.cycle.start_date | prDate }}</span>
                            </v-flex>
                            <v-flex xs12 md3>
                              <span class="grey--text">Prioridade:</span>
                              <br>
                              <skeleton duration=".6" theme="flex-outer" style="width: 100px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                                <tb-skeleton :aspect-ratio="0.2"></tb-skeleton>
                              </skeleton>
                              <span v-if="called.id">{{ called.priority ? called.priority.description : '' }}</span>
                            </v-flex>
                            <v-flex xs12 md3 v-if="called.total_worked_hours">
                              <span class="grey--text">Total Horas Trabalhadas</span>
                              <br>
                              <skeleton duration=".6" theme="flex-outer" style="width: 100px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                                <tb-skeleton :aspect-ratio="0.2"></tb-skeleton>
                              </skeleton>
                              <span v-if="called.id">{{ called.total_worked_hours }}h</span>
                            </v-flex>
                            <v-flex v-if="called.panel_link && called.panel_link !== ''" xs12 md3>
                              <span class="grey--text">Painel:</span>
                              <br>
                              <skeleton duration=".6" theme="flex-outer" style="width: 100px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                                <tb-skeleton :aspect-ratio="0.2"></tb-skeleton>
                              </skeleton>
                              <a
                                v-if="called.id"
                                :href="called.panel_link"
                                target="_blank"
                                class="follow-called-panel-link"
                              >
                                ABRIR PAINEL
                                <v-icon color="primary" small>open_in_new</v-icon>
                              </a>
                              <v-tooltip v-if="called.id" top>
                                <template slot="activator">
                                  <v-btn
                                    color="primary"
                                    flat
                                    icon
                                    small
                                    v-clipboard="called.panel_link"
                                    @success="handleSuccess"
                                    @error="handleError">
                                    <v-icon small>content_copy</v-icon>
                                  </v-btn>
                                </template>
                                <span>Copiar Link</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                          <v-divider class="mb-3" v-if="called.linked && called.linked.length > 0"></v-divider>
                          <v-layout row wrap v-if="called.linked && called.linked.length > 0">
                            <v-flex xs12 class="data-called-linked">
                              <strong>Chamados Vinculados:</strong>
                            </v-flex>
                            <v-flex xs12 class="data-called-linked">
                              <v-data-table
                                :headers="headers"
                                :items="called.linked"
                                :total-items="called.linked.length"
                                :hide-actions="true"
                                class="elevation-0">

                                <template slot="items" slot-scope="props">
                                  <td>
                                    <router-link :to="{ name: 'follow-called', params: { id: props.item.id }}" target="_blank">
                                      #{{ props.item.id }}
                                    </router-link>
                                  </td>
                                  <td>
                                    <router-link :to="{ name: 'follow-called', params: { id: props.item.id }}" target="_blank">
                                      {{ props.item.title }}
                                    </router-link>
                                    <v-icon color="primary" small>open_in_new</v-icon>
                                  </td>
                                  <td>
                                    {{ props.item.project.name }}
                                  </td>
                                  <td>
                                    {{ props.item.priority.description }}
                                  </td>
                                  <td>
                                    {{ props.item.cycle.name }}
                                  </td>
                                  <td>
                                    {{ props.item.called_status.description }}
                                  </td>
                                  <td class="text-xs-center">
                                    <v-tooltip top>
                                      <template slot="activator">
                                        <v-btn color="primary" flat icon @click="removeLink(props.item.id)">
                                          <v-icon>close</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>Remover Vínculo</span>
                                    </v-tooltip>
                                  </td>
                                </template>
                              </v-data-table>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap v-if="(called.files && called.files.length > 0)">
                            <v-flex xs12>
                              <v-list class="pa-0">
                                <v-subheader class="pl-0">Anexos:</v-subheader>
                                <v-list-tile
                                  avatar
                                  ripple
                                  @click="download(file.filename, file.archivable_type, file.archivable_id)"
                                  v-for="file in called.files"
                                  :key="file.id">
                                  <v-list-tile-avatar>
                                    <v-icon class="grey white--text">attach_file</v-icon>
                                  </v-list-tile-avatar>

                                  <v-list-tile-content>
                                    <v-list-tile-title>{{ file.filename }}</v-list-tile-title>
                                    <v-list-tile-sub-title v-if="file">
                                      {{ file.size | convertToByte }} - Data de criação: {{ file.created_at | prDate }}
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>

                                  <v-list-tile-action>
                                    <v-icon color="grey lighten-1">archive</v-icon>
                                  </v-list-tile-action>
                                </v-list-tile>
                              </v-list>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap mt-3>
                            <v-flex xs12 class="data-called-desciption">
                              <strong>Descrição:</strong>
                              <v-divider class="mb-3"></v-divider>
                              <skeleton duration=".6" theme="flex-outer" style="width: 65%" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                                <tb-skeleton :aspect-ratio="0.05"></tb-skeleton>
                              </skeleton>
                              <span v-html="called.description" v-if="called.id"></span>
                            </v-flex>
                          </v-layout>

                          <v-layout v-if="called.monitors && called.monitors.length > 0" row wrap class="mt-4">
                            <v-flex xs12 md12>
                              <v-card>
                                <v-card-title>
                                  <strong>Monitorado Por:</strong>
                                </v-card-title>
                                <v-data-table
                                  :items="called.monitors"
                                  hide-headers
                                  hide-actions
                                  no-data-text="Nenhum dado foi adicionado."
                                  density="compact"
                                  class="elevation-1">
                                  <template slot="items" slot-scope="props">
                                    <td>{{ props.item.target }}</td>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </v-flex>
                          </v-layout>

                          <v-layout v-if="showCalledSimilars({ called })" row wrap mt-3>
                              <v-flex xs12 class="data-called-desciption">
                                <v-divider class="mb-3"></v-divider>
                                <strong>Indicação de solução Biana:</strong>
                                <div>{{ called.similar_called.solucao_indicada ? called.similar_called.solucao_indicada : 'Nenhuma solução foi encontrada' }}</div>
                                <div class="mt-2">
                                  <strong>Chamado Relacionados:</strong>
                                  <template v-if="called.similar_called.similar_historical_chamados">
                                    <v-btn
                                      v-for="similar in getSimilarCalled({ similarCalled: called.similar_called.similar_historical_chamados })"
                                      :key="similar"
                                      color="primary"
                                      small
                                      round
                                      @click="openCalledNewTab({ similar })"
                                    >
                                      {{ similar }}
                                    </v-btn>
                                  </template>
                                </div>
                              </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <!-- Sessão Dados do chamado" -->

                  <!-- Sessão Pessoas envolvidas no chamado" -->
                  <v-flex xs12 md4>
                    <v-system-bar status color="blue lighten-4" class="pa-3">
                      <span class="primary--text">Pessoas</span>
                    </v-system-bar>
                    <v-list two-line>
                      <template v-for="(csu, index) in called.called_users">
                        <v-list-tile avatar :key="index">
                          <v-list-tile-avatar>
                            <img :src="(csu.user.image) ? csu.user.image : '/static/no_avatar.gif'" alt="no image">
                          </v-list-tile-avatar>

                          <v-list-tile-content>
                            <v-list-tile-title>
                              <skeleton duration=".6" theme="flex-inner" style="width: 280px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                                <tb-skeleton :aspect-ratio="0.07"></tb-skeleton>
                              </skeleton>
                              <span v-if="called.id">{{ csu.user.name }}</span>
                            </v-list-tile-title>
                            <v-list-tile-sub-title>
                              <skeleton duration=".6" theme="flex-inner" style="width: 300px" shape="radius" bg-color="#dcdcdc" v-if="!called.id">
                                <tb-skeleton :aspect-ratio="0.05"></tb-skeleton>
                              </skeleton>
                              <span v-if="called.id">{{ csu.event + ' o chamado em: '}} {{ csu.created_at | prDateTime }}</span>
                            </v-list-tile-sub-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-list>
                  </v-flex>
                  <!-- Sessão Pessoas envolvidas no chamado" -->
                </v-layout>
              </v-layout>
            </v-tab-item>
            <v-tab-item value="tab-historico" v-if="called.id" class="tab-historico">
              <v-timeline>
                <v-timeline-item
                  small
                  color="info darken-3"
                  v-for="(history) in callHistories"
                  :key="history.id">
                  <v-avatar slot="icon" v-if="history.user.image">
                    <img :src="history.user.image">
                  </v-avatar>
                  <span slot="opposite">
                    <span class="grey--text">{{ history.date | prDate }}</span><br>
                    <span class="primary--text display-2">
                      {{ history.created_at | prTime }}
                    </span>
                  </span>
                  <v-card ripple>
                    <v-bottom-sheet full-width :disabled="history.is_first">
                      <v-card-title slot="activator" :ref="`bottomSheet${history.id}`" class="title white--text info darken-3 card-hover">
                        <v-layout row wrap>
                          <v-flex xs12 md7>
                            <span class="subheading">
                              {{ history.is_first ? 'Criado por:' : 'Atualizado por:' }}
                            </span><br>
                            {{ history.user.name }}
                          </v-flex>
                          <v-flex xs12 md5 text-md-right v-if="history.worked_hours">
                            <v-chip label color="white" text-color="primary">
                              <v-icon class="mr-1" left>query_builder</v-icon>
                              Horas Trabalhadas: {{ convertMinutesToHours(history.worked_hours) }}h
                            </v-chip>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                      <v-alert :value="true" color="info darken-3">
                        <div style="text-align: center;">
                          <v-btn @click="editCalled(history)"><v-icon small>edit</v-icon> Editar</v-btn>
                          <v-btn color="error" @click="deleteCallHistory(history.id)">
                            <v-icon small>delete</v-icon> Remover
                          </v-btn>
                        </div>
                      </v-alert>
                    </v-bottom-sheet>
                    <v-card-text class="white grey--text text--darken-2">
                      <v-chip
                        disabled
                        label
                        small
                        outline
                        color="secondary ma-0"
                        class="caption"
                        v-if="history.before_called_status_id !== history.after_called_status_id">
                        Status Alterado de <i class="font-weight-bold">&nbsp;{{ history.before_called_status.description }}&nbsp;</i>
                        para <i class="font-weight-bold">&nbsp;{{ history.after_called_status.description }}&nbsp;</i>
                      </v-chip>
                      <v-chip
                        disabled
                        label
                        small
                        outline
                        color="error ma-0"
                        class="caption"
                        v-if="history.before_priority_id !== history.after_priority_id">
                        Prioridade Alterada de <i class="font-weight-bold">&nbsp;{{ history.before_priority.description }}&nbsp;</i>
                        para <i class="font-weight-bold">&nbsp;{{ history.after_priority.description }}&nbsp;</i>
                      </v-chip>
                      <p
                        class="mt-3 called-description"
                        v-if="history.description"
                        v-html="history.description">
                      </p>
                      <v-list class="pa-0" v-if="history.files && history.files.length > 0">
                        <v-subheader>Anexos:</v-subheader>
                        <v-list-tile
                          avatar
                          ripple
                          @click="download(file.filename, file.archivable_type, file.archivable_id)"
                          v-for="file in history.files"
                          :key="file.id">
                          <v-list-tile-avatar>
                            <v-icon class="grey white--text">attach_file</v-icon>
                          </v-list-tile-avatar>

                          <v-list-tile-content>
                            <v-list-tile-title>{{ file.filename }}</v-list-tile-title>
                            <v-list-tile-sub-title>
                              {{ file.size | convertToByte }} - Data de criação: {{ file.created_at | prDate }}
                            </v-list-tile-sub-title>
                          </v-list-tile-content>

                          <v-list-tile-action>
                            <v-icon color="grey lighten-1">archive</v-icon>
                          </v-list-tile-action>
                        </v-list-tile>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>
<script>
import axios from 'axios';
import i18n from '@/i18n';
import { padStart as _padStart } from 'lodash';
import CalledService from '@/features/called/CalledService';
import EditCalledDialog from '@/features/follow-called/EditCalledDialog';
import CallHistoryService from '@/features/call-histories/CallHistoryService';
import UserService from '@/features/user/UserService';

export default {
  name: 'follow-called',
  data() {
    return {
      headers: [
        {
          text: this.$t('attributes.called.number'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.title'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.project'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.priority'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.called.cycle'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.status'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
      showBottomSheet: false,
      calledId: null,
      callHistories: [],
      tabActive: 'tab-dados',
      called: {},
      cycleStatus: {
        sim: 'Ativo',
        nao: 'Inativo',
      },
      calledService: new CalledService(),
      callHistoryService: new CallHistoryService(),
    };
  },
  created() {
    this.calledId = this.$route.params.id;
    this.searchCalled();
  },
  watch: {
    tabActive() {
      if (this.tabActive === 'tab-historico') {
        this.searchCalledHistory();
      } else {
        this.searchCalled();
      }
    },
  },
  methods: {
    async searchCalled() {
      this.called = await this.calledService.get(this.calledId);
    },
    download(filename, archivableType, archivableId) {
      const type = archivableType.split('\\');
      axios.get('file-download', {
        params: { id: archivableId, archivable_type: type[1], name_file: filename },
        responseType: 'blob',
      }).then((res) => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        const file = new Blob([res.data], { type: res.headers['content-type'] });
        const fileURL = URL.createObjectURL(file);
        a.href = fileURL;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(fileURL);
      });
    },
    editCalled(history) {
      let dataValue = this.called;
      if (history) {
        dataValue = this.callHistories.find(item => item.id === history.id);
      }

      this.$dialog.component(
        EditCalledDialog,
        {
          closeWithEsc: false,
          closeWithMask: false,
          widget: false,
          width: '60%',
          dataValue,
        },
      )
      .then(() => {
        if (this.tabActive === 'tab-historico') {
          this.searchCalledHistory();
          if (history) {
            this.$refs[`bottomSheet${history.id}`][0].click();
          }
        }
        this.searchCalled();
      });
    },
    verifyColorCalledStatus(calledStatus) {
      const color = {
        fechado: 'error',
        aberto: 'primary',
      };
      if (!(calledStatus.slug in color)) return 'success';
      return color[calledStatus.slug];
    },
    verifyIconCalledStatus(calledStatus) {
      const icon = {
        fechado: 'lock',
        aberto: 'lock_open',
      };
      if (!(calledStatus.slug in icon)) return 'assignment_turned_in';
      return icon[calledStatus.slug];
    },
    verifyColorCycleStatus(cycleStatus) {
      const color = {
        nao: 'error',
        sim: 'primary',
      };
      return color[cycleStatus];
    },
    verifyIconCycleStatus(cycleStatus) {
      const icon = {
        nao: 'lock',
        sim: 'lock_open',
      };
      return icon[cycleStatus];
    },
    goToBack() {
      this.$router.push({ name: 'called-list' });
    },
    updateCalledData() {
      this.searchCalled();
    },
    convertMinutesToHours(time) {
      if (time < 1) {
        return '--';
      }
      const hours = Math.floor(time / 60);
      const minutes = (time % 60);
      return `${_padStart(hours, 2, '0')}:${_padStart(minutes, 2, '0')}`;
    },
    async searchCalledHistory() {
      await this.callHistoryService.query({ called_id: this.calledId })
        .then((response) => {
          this.callHistories = response;
        });
    },
    deleteCallHistory(id) {
      this.$dialog.confirm({ title: 'Atenção', content: 'Deseja apagar o histórico selecionado?' })
        .then((response) => {
          if (response.action === 'ok') {
            this.callHistoryService.destroy(id).then(() => {
              this.$toast.success(i18n.t('messages.removeSuccess'));
              this.searchCalledHistory();
              this.updateCalledData();
            });
          }
        });
    },
    async removeLink(linkedId) {
      const dialog = await this.$dialog.confirm({
        title: 'Confirmação ',
        content: `Deseja realmente excluir o chamado #${linkedId} vinculado?`,
      });
      if (dialog.action === 'ok') {
        const linked = this.called.linked.filter(item => item.id !== linkedId);
        const result = await this.calledService.request(
          'POST',
          'update-linked',
          {
            id: this.called.id,
            linked: linked.map(item => item.id),
          },
        );
        this.called.linked = result.data;
      }
    },
    openCalledNewTab({ similar }) {
      const params = { id: similar };
      const routeData = this.$router.resolve({ name: 'follow-called', params });
      window.open(routeData.href, '_blank');
    },
    getSimilarCalled({ similarCalled }) {
      return similarCalled.split(';').map(Number).sort((a, b) => a - b);
    },
    showCalledSimilars({ called }) {
      return called && called.similar_called && UserService.hasProfile(this.$store.state.currentUser, ['master', 'admin', 'analista']);
    },
    handleSuccess() {
      this.$toast.success('Link copiado com sucesso!');
    },
    handleError() {
      this.$toast.error('Erro ao tentar copiar o link, tente novamente.');
    },
  },
};
</script>
<style scoped>
  .v-card__text {
    border: 1px solid #e0e0e0;
  }
  .called-description {
    border-top: 1px solid #ccc;
    padding-top: 10px;
    border-bottom: 1px solid #ccc;
    margin-bottom: unset;
  }
  .data-called-desciption {
    min-height: 70px;
  }
  .card-hover {
    cursor: pointer;
  }
  .alert-status-height {
    height: 80px !important;
  }
  .follow-called-panel-link {
    text-decoration: unset;
    border: solid 1px;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/features/follow-called/FollowCalled.vue